import UpdatePriceSlider from "./updatePriceSlider";
import initEroticInfoBox from "../../header/components/initEroticInfoBox";
import equalHeight from "../../equalHeight";
import { CartProductsActivation } from "../../cart/components/cart";
import InsertPager from "./insertPager";
import initStarRating from "./initStarRating";
import GetSelectedTab from "./getSelectedTab";
import nouisliderJs from "../../../libraries/nouislider.min";
import tinyNavJs from "../../../libraries/tinynav.min";

export default function LoadMoreApptus(pageIndex, id) {
  nouisliderJs();
  tinyNavJs();
  var pageSize = $(".selVisaFler").val();
  var letter = $(".alphabet-filter li.active").text();
  if ($(".alphabet-filter .tinynav:visible").length > 0) {
    letter = $(".alphabet-filter .tinynav option:selected").text();
    if (letter == "Välj") {
      letter = "";
    }
  }
  if (typeof (id) === "undefined" || id.length < 1) {
    var $selectedTab = GetSelectedTab();

    id = $selectedTab.attr('id');
    if (id == "SO_PRICE" && $(".discount-link").hasClass("active")) {
      id = "SO_PLO2";
    }
  }

  var eroticHolder = $(".erotik-view .show_erotik");
  var isErotikChecked = eroticHolder.length > 0
    ? eroticHolder.prop("checked")
    : $.cookie('isErotikOn') === "True";
  var priceRange = $("#min_range").val() + "," + $("#max_range").val();
  $.ajax({
    url: "/api/Apptus/Search",
    data:
    {
      pageSize: pageSize,
      pageIndex: pageIndex,
      sort: id,
      cache: false,
      isErotikOn: isErotikChecked,
      priceRange: priceRange,
      letter: letter,
      s: $('#search-input').val(),
      isError: $('.error-text-msg').length > 0
    },
    async: true,
    beforeSend: function () {

      $(".product-list-holder .product_item").fadeOut(100);
    },
    complete: function () {

    },
    success: function (data) {
      if (data != null) {
        if (data.MaxMinPrices) {
          window.maxPriceFacetValue = data.MaxMinPrices.Max;
          window.minPriceFacetValue = data.MaxMinPrices.Min;
          $('#min_range').val(data.MaxMinPrices.CurrentMin);
          $('#max_range').val(data.MaxMinPrices.CurrentMax);
          if (data.MaxMinPrices.Min == data.MaxMinPrices.Max) {
            $('#keypress').attr('disabled', ' disabled');
          }
          else {
            UpdatePriceSlider(data.MaxMinPrices.Min, data.MaxMinPrices.Max, data.MaxMinPrices.CurrentMin, data.MaxMinPrices.CurrentMax);
            $('#keypress').removeAttr('disabled');
          }
        }
        $(".product-list-holder .product_item").remove();

        if (data.totalCount == "0" || data.totalCount <= parseInt(pageSize)) {
          $(".show_more").hide();
        }
        else {
          $(".show_more").show();
        }

        if (data.totalCount == "0") {
          $(".zeroResults").show();
        }
        else {
          $(".zeroResults").hide();
          var template = $.templates('#GalleryBlocks');
          var outerHtml = template.render(data);
          $(".product-list-holder").append(outerHtml);
            
          if ($(".grid-view").is(":visible")) {
            $('.grid-view').imagesLoaded().always(function () {
              equalHeight('.grid-view .product-list-holder .product_item-img');
              equalHeight('.grid-view .product-list-holder .title');

            });
          }
          $(".searchHeader .search-count").text(data.totalCountWithErotic == "10000" ? data.totalCountWithErotic + "+" : data.totalCountWithErotic);
          $(".search-result_holder .count").text("Antal traffar: " + data.totalCountWithErotic);
          $(".search-result_holder .count").show();
        }

        if (data.totalCount == "10000" && Math.ceil(parseInt(data.totalCount) / parseInt(pageSize)) == pageIndex) {
          $(".more10k").show().insertBefore(".show_more");
        }
        else {
          $(".more10k").hide();
        }

        if (data.isShowEroticInfo) {
          if ($('.search_phrase').val() != '') {
            $("div.h3EroticInfoText").show();
          }
          else {
            $("li.h3EroticInfoText").show();
          }
          initEroticInfoBox();
        }
        else {
          $(".h3EroticInfoText").hide();
        }

        CartProductsActivation();

        InsertPager(data.totalCount, data.page, false);

        var url = window.location.pathname;
        var scrollPos = sessionStorage.getItem('productURL' + url);
        if (scrollPos) {
          $(window).scrollTop(scrollPos);
          sessionStorage.removeItem('productURL' + url);
        }

        $(".selVisaFler").blur();
        initStarRating();
        if ($(".grid-view").is(":visible")) {
          $('.grid-view').imagesLoaded().always(function () {
            equalHeight('.grid-view .product-list-holder .product_item-img');
            equalHeight('.grid-view .product-list-holder .title');

          });
        }

      }
    }
  });
}